export const MinimumRequiredAdminsErrorMessage =
  'This operation would result in zero admins for the company. The minimum required admins for each company is 1.';

export const MinimumRequiredQualityUsersErrorMessage = 'Company requires at least one Quality user.';

export const DocumentsHiddenFromAuthorsErrorMessage =
  'This action would cause one or more documents to be hidden from their authors.'; // Deprecated

export const DocumentsHiddenFromOwnersErrorMessage =
  'This action would cause one or more documents to be hidden from their owners.';

export const TemplatesHiddenFromOwnersErrorMessage =
  'This action would cause one or more templates to be hidden from their owners.';

export const AlreadyActiveUserErrorMessage = (email: string) =>
  `User registered with email ${email} is already a member of this company.`;

export const TotalUsersLimitReachedErrorMessage = 'Limit of total users reached.';
export const ActiveUsersLimitReachedErrorMessage = 'Limit of active users reached.';
export const InvalidEmailErrorMessage = 'Invalid email address.';
export const UserEmailAlreadyUsed = 'A user already exists in Qualio with this email address.';
